import api from '../requests';

export async function getTotalSummary (params) {
  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/total`,
    params: {
      date: params.date
    }
  });
  return response.data;
}

export async function getSkuSummary (params) {
  //  console.log('param', params);

  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/sku`,
    params: {
      date: params.date,
      mpid: params.mpid
    }
  });
  return response.data;
}

export async function getSymbolSummary (params) {
  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/symbol`,
    params: {
      date: params.date
    }
  });
  return response.data;
}

export async function getFirmSummary (params) {
  //  console.log('param', params);

  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/firm`,
    params: {
      date: params.date
    }
  });
  return response.data;
}

export async function getVenueSummary (params) {
  //  console.log('param', params);

  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/venue`,
    params: {
      date: params.date
    }
  });
  return response.data;
}

export async function getVenueRangeSummary (params) {
  //  console.log('param', params);

  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/venue/range`,
    params: {
      startDate: params.startDate,
      endDate: params.endDate
    }
  });
  return response.data;
}

export async function getDailySummary (params) {
  //  console.log('param', params);

  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/daily`,
    params: {
      startDate: params.startDate,
      endDate: params.endDate
    }
  });
  return response.data;
}

export async function getChartSummary (params) {

  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/chart`,
    params: {
      date: params.date,
      mpid: params.mpid
    }
  });
  return response.data;
}

/// / ECN market data summary API

// this returns data from ecn market data service
export async function getTotalSummaryFromEcn (params) {
  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/ecn-market-total`
  });
  return response.data;
}

// this returns data from ats market data service
export async function getTotalSummaryFromAts (params) {
  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/ats-market-total`
  });
  return response.data;
}

export async function getTotalSummaryFromIdqs (params) {
  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/idqs-market-total`
  });
  return response.data;
}

export async function getTotalSummaryFromIdqsNight (params) {
  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/idqs-night-market-total`
  });
  return response.data;
}

export async function getTotalSummaryFromIdqsNms (params) {
  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/idqs-nms-market-total`
  });
  return response.data;
}

export async function getTotalSummaryFromTdds (params) {
  const response = await api.request({
    method: 'get',
    url: `/internal/summary-data/tdds-market-total`
  });
  return response.data;
}
